module.exports = __webpack_public_path__ + "static/evolutionDiagram-5c5275af716665398f19d79668154364.svg";